import Divider from "antd/lib/divider";
import Visualization from "./Visualization/Visualization";
import { Configuration } from "../Components/Configuration";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Note from "../Components/Note";
import Handbook from "./Handbook";
import React, { useEffect, useState } from "react";
import Layout from "antd/lib/layout";
import { useSelector } from "react-redux";
import { pauseTimeline, resumeTimeline } from "Services/timeline.service";
import { Node } from "Models/node";
import { getConfig, getPaused, getMenuOpen, getRunSeed } from "Redux/selectors";
import { ActionBar } from "./ActionBar";
import "./Main.css";
import {
    setup,
    reset as resetVisualization,
} from "Services/visualization.service";
import { toggleNode as toggleNodeState } from "Services/nodes.service";

const { Content } = Layout;

export const Main: React.FC = () => {
    const config = useSelector(getConfig);
    const paused = useSelector(getPaused);
    const menuOpen = useSelector(getMenuOpen);
    const runSeed = useSelector(getRunSeed);
    // TODO: remove, unnecessary state
    const [update, setUpdate] = useState(0);

    useEffect(() => {
        if (!config) return;

        setup(config);
        setUpdate((prevUpdate) => prevUpdate + 1);
    }, [config]);

    const reset = () => resetVisualization();
    const togglePause = () => (paused ? resumeTimeline() : pauseTimeline());
    const toggleNode = (node: Node) => {
        toggleNodeState(node);
        setUpdate(update + 1);
    };

    return (
        <Layout className="Main">
            {menuOpen && (
                <Content className="Main__sider">
                    <Header />
                    <Configuration />
                    <Note />
                    <Handbook />
                    <Footer />
                </Content>
            )}
            <Content className="Main__content">
                <ActionBar togglePause={togglePause} reset={reset} />
                <Divider />
                <Visualization toggleNode={toggleNode} key={runSeed} />
            </Content>
        </Layout>
    );
};
